'use strict';

function dataLayerPush(object) {
    setTimeout(function() { // setTimeout moves this function off the main thread to break long task
        window.dataLayer.push(object);
    }, 0);
};

// subdomain critical substrings mapping with specific label
const subdomains = {
    'shop.brunellocucinelli': 'BOUTIQUE ONLINE',
    'investor.brunellocucinelli': 'INVESTOR RELATIONS',
    'brunellocucinelli.ai': 'CUCINELLI AI',
    'humanresources.html': 'HUMAN RESOURCES'
};

// construct the selector dynamically based on domains
var trackedLinksSelector = Object.keys(subdomains)
    .map(d => `a[href*='${d}']`)
    .join(',');

// analytics update for link click
$(document).on('click', trackedLinksSelector, function () {
    const href = $(this).attr('href');
    var dl = {
        event: 'internal_link',
        click_type: $(this).closest('footer').length > 0 ? 'footer_click' : 'link_click',
        link_label: subdomains[Object.keys(subdomains).find(key => href.includes(key))],
        link_url: href
    };
    dataLayerPush(dl);
});

// main datalayer pupulation
$(document).ready(function () {
    if ($('#analytics-corporate').length > 0) {
        var data = JSON.parse($('#analytics-corporate').val());
        var dl = {
            pageCategory: data ? data.category : '',
            pagesubCategory: data ? data.subCategory : '',
            pageDetail: data ? data.detail : '',
            pageStatus: data ? data.status : '',
            pageLanguage: data ? data.language : ''
        };
        window.dataLayer.push(dl); // pushing base datalayer info without settimeout
    }
});
